export enum Currency {
    ALL = 1,
    EUR,
    USD,
    XCD
}
